function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.01 1.89A1.89 1.89 0 0017.12 0H1.89A1.89 1.89 0 000 1.89v7.86a1.89 1.89 0 001.89 1.89h4.67l-.06.14L5.33 15c-.15.4-.08.63.13.63a.87.87 0 00.44-.18l5.2-3.81h6a1.89 1.89 0 001.89-1.89V1.89z"
});

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19 15.63"
  }, props), _ref);
};

export default SvgChat;